<template>
  <div class="active-schools">
    <h1 class="text-center my-7">درخواست های مدرسه ای تایید نشده</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-data-table :headers="headers" :items="schools" :items-per-page="10">
          <template v-slot:[`item._id`]="{ item }">
            <div class="d-flex">
              <v-btn
                depressed
                small
                color="success"
                @click="activeSchool(item._id)"
              >
                فعال سازی
              </v-btn>
              <v-btn
                depressed
                small
                color="error"
                class="mr-2"
                @click="rejectSchool(item._id)"
              >
                رد درخواست
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.requestDate`]="{ item }">
            <persian-date :date="item.requestDate" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "../_Navigation.vue";
export default {
  name: "active-school-component",
  components: {
    Navigation
  },
  data: () => {
    return {
      schools: [],
      headers: [
        { text: "نام مدرسه", value: "title", align: "center" },
        { text: "نام مدیر", value: "moderator", align: "center" },
        { text: "نام رابط", value: "coordinator", align: "center" },
        { text: "شماره تماس", value: "mobilenumber", align: "center" },
        { text: "استان", value: "state", align: "center" },
        { text: "تاریخ درخواست", value: "requestDate", align: "center" },
        { text: "عملیات", value: "_id", align: "center" }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api
        .get("/schools/pending")
        .then((res) => {
          this.schools = res.data.schools;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    activeSchool(id) {
      const schoolId = id;
      this.$api
        .post("/user/activeSchool", {
          school: schoolId
        })
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    rejectSchool(id) {
      const schoolId = id;
      this.$api
        .post("/school/delete", {
          school: schoolId
        })
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>
